import { faEdit } from '@fortawesome/free-solid-svg-icons'

import ModalUpdateMerchantProfile from 'components/MerchantProfileShell/SideBar/ModalUpdateMerchantProfile'
import ModalUpdateMerchantStatus from 'components/MerchantProfileShell/SideBar/ModalUpdateMerchantStatus'

import {
  accessControlSubNavigationWithUserTypes,
  accessControlStatus,
} from 'setups/controller'
import { projectClient } from 'constants/project'
import { UserTypeNames } from 'setups/usertypes'

export const DROPDOWN_OPTIONS = [
  {
    module: 'Update Merchant Profile',
    label: 'Update Merchant Profile',
    value: '1',
    route: {
      title: 'update merchant profile',
      path: {
        path: '',
        permissionIds: [],
      },
      icon: faEdit,
    },
    Modal: ModalUpdateMerchantProfile,
  },
  {
    module: 'Update Merchant Status',
    label: 'Update Merchant Status',
    value: '2',
    route: {
      title: 'update merchant status',
      path: {
        path: '',
        permissionIds: [],
      },
      icon: faEdit,
    },
    Modal: ModalUpdateMerchantStatus,
  },
]

export const MERCHANTELLIPSISNAVIGATION_FN = (
  userType: string,
  navModule: string,
  thorUserStatus: string
) => {
  const checkAccessViaHDAUser = accessControlSubNavigationWithUserTypes({
    projectClient,
    navModules: DROPDOWN_OPTIONS,
    navModule: 'merchant',
    userType: userType as UserTypeNames,
    isTempBypass: false,
  })
  return accessControlStatus(checkAccessViaHDAUser, navModule, thorUserStatus)
}
